// import {defineLordIconElement} from 'lord-icon-element';
import lottie from 'lottie-web';
import { rgbaToHexA } from './functions';
import {isDesktop} from "./settings";
import { defineElement } from "@lordicon/element";
import {BaseElement} from "./modules/interfaces/BaseElement";

// defineLordIconElement(lottie.loadAnimation);
defineElement(lottie.loadAnimation);

const lordIcons = {
  '2D': '731-real-estate-building-project-outline-edited.json',
  'keyPlan': '731-real-estate-building-project-outline-edited.json',
  '360View': '1434-360-view-outline-edited.json',
  '360': '1434-360-view-outline-edited.json',
  '3dModel': '63-home-outline-edited.json',
  about: '425-exclamation-mark-bubble-outline-edited.json',
  backArrow: '217-arrow-6-edited.json',
  celsius: '823-celsius-temperature-outline-edited.json',
  checked: '37-approve-checked-simple-outline-edited.json',
  clouds: '801-two-clouds-outline-edited.json',
  contactUs: '140-earphone-telephone-outline-edited.json',
  compare: '1409-compare-outline-edited.json',
  document: '245-edit-document-outline-edited.json',
  drizzle: '807-mild-rain-outline-edited.json',
  favorite: '1453-card-heart-outline-edited.json',
  gallery: '54-photo-picturellandscape-gallery-outline-edited.json',
  getApp: '1335-qr-code-outline-edited.json',
  lang: '27-globe-outline-edited.json',
  map: '18-location-pin-outline-edited.json',
  More: '319-menu-6-morph-outline-edited.json',
  onBoardingSwipe: '1444-swipe-left-right-outline-edited.json',
  play: '830-plane-2-outline-edited.json',
  print: '732-printer-outline-edited.json',
  rain: '808-heavy-rain-outline-edited.json',
  rotate: '250-smartphone-rotate-morph-outline-edited.json',
  search: '19-magnifier-zoom-search-outline-edited.json',
  scanIcon: '1686-scan-qr-code-outline-edited.json',
  snow: '815-snow-flake-outline-edited.json',
  soundOn: '191-speaker-outline-edited.json',
  soundOff: '192-speaker-off-on-morph-outline-edited.json',
  thunderstorm: '808-heavy-rain-outline-edited.json',
  vantage: '741-binoculars-telescope-outline-edited.json',
  clear: '804-sun-outline-edited.json',
  bicycle: '488-bicycle-outline-edited.json',
  railway: '834-train-outline-edited.json',
  highway: '922-highway-outline-edited.json',
  bus: '968-bus-front-outline-edited.json',
  parks: '1935-park-bench-outline-edited.json',
  education: '486-school-outline-edited.json',
  leisure: '1574-spa-flower-outline-edited.json',
  fun: '1549-culinary-and-heritage-expeditions-edited.json',
  deals: '1339-sale-outline-edited.json',
  documents: 'wired-outline-56-document.json',
  playBouncy: 'wired-outline-29-play-bouncy.json',
  edit: 'wired-outline-35-edit.json',
  edit2: 'wired-outline-245-edit-document.json',
  engagement: 'wired-outline-2803-engagement-alt-hover-pinch.json'
};

const lordIconsGlobalSettings = {
  trigger: 'loop',
  delay: '2000',
  stroke: '100'
};

// let primaryColor = null;
// let secondaryColor = null;
// let activeColor = null;

export const lordIconColors = {
  primary: null,
  secondary: null,
  active: null,
  customColors: {}
};

export function getLordIconColors () {
  // const {primary,secondary} = config.features.icons.color;
  lordIconColors.primary = config.features.icons.color.primary;
  lordIconColors.secondary = config.features.icons.color.secondary;

  const primaryRgba = {
    value:
        document.body.classList.contains('light-theme')
            ? '1,1,1,1'
            : config.style.colors.find(color => color.key === lordIconColors.primary)?.value
  };
  const secondaryRgba = {
    value:
        document.body.classList.contains('light-theme')
            ? '1,1,1,1'
            : config.style.colors.find(color => color.key === lordIconColors.secondary)?.value
  };

  const brand2ColorCode = document.querySelector(':root').style.getPropertyValue('--brand2').match(/\((.*)\)/)[1];
  const lightThemeActiveColor = {value: brand2ColorCode};
  const activeRgba = document.body.classList.contains('light-theme') ? lightThemeActiveColor : config.style.colors.find(color => color.key === 'brand2');

  lordIconColors.primary = rgbaToHexA(primaryRgba.value.split(','),false);
  lordIconColors.secondary = rgbaToHexA(secondaryRgba.value.split(','),false);
  lordIconColors.active = rgbaToHexA(activeRgba.value.split(','), false);
}

export function setLordIcon (name,parentContainer,parameters = {},position, isActive = false) {
  const iconsPath = './img/lordIcons/';
  const lordIcon = lordIcons[name];

  if (!parentContainer || !lordIcon)
    return;

  let icon;

  icon = new BaseElement('lord-icon')
      .addClass('lord__icon')
      .setAttributes({
        'src': iconsPath + lordIcon,
        'data-menu-item': name,
        'target': parentContainer.tagName,
        'activeIcon':  false,
      })
      .event('ready',() => {
        if (icon && icon.DOMElement.playerInstance?._container.children.length > 3)
          icon.DOMElement.iconChanged();
      });

  if (parameters?.id) {
    lordIconColors.customColors[parameters.id] = {};
    lordIconColors.customColors[parameters.id].primaryColor = parameters.primaryColor;
    lordIconColors.customColors[parameters.id].secondaryColor = parameters.secondaryColor;
    icon.addAttribute('custom-color-id', parameters.id);
  }

  parentContainer.setAttribute('lord-icon-name',name);

  Object.entries(lordIconsGlobalSettings).forEach(([key,value]) =>{
    icon.addAttribute(key,value);
  });

  icon.addAttribute(
      'colors',
      `primary:${parameters?.id ? parameters.primaryColor : lordIconColors.primary},secondary:${parameters?.id ? parameters.secondaryColor : lordIconColors.secondary}`);

  if (isActive) {
    // icon.setAttribute('activeIcon', true);
    // icon.setAttribute('colors',`primary:${activeColor},secondary:${activeColor}`);
    icon.setAttributes({
      'activeIcon': true,
      'colors': `primary:${lordIconColors.active},secondary:${lordIconColors.active}`
    })
  }

  if (Object.keys(parameters).length) {
    Object.entries(parameters).forEach(([key,value]) =>{
      icon.addAttribute(key,value);
    });
  }

  if (position){
    parentContainer.insertAdjacentElement(position, icon.DOMElement);
  } else {
    parentContainer.appendChild(icon.DOMElement);
  }

  return icon.DOMElement;
}

export function unsetLordIcon(name, parentContainer) {
  const iconElementToRemove = parentContainer.querySelector(`lord-icon[data-menu-item="${name}"]`);
  if (iconElementToRemove) {
    iconElementToRemove.remove();
  }
}

export function setActiveLordIcon (name,parentContainer) {
  const activeIcon = getLordIcon(undefined,parentContainer);
  activeIcon && toggleIconParams(activeIcon);

  if (name === 'search' && isDesktop)
    return;


  const icon = getLordIcon(name,parentContainer);
  icon && toggleIconParams(icon);
}

function getLordIcon (name,parentContainer) {
  if (name){
    return parentContainer.querySelector(`lord-icon[data-menu-item="${name}"]`);
  } else {
    return parentContainer.querySelector('lord-icon[activeIcon="true"]');
  }
}

export function toggleIconParams (icon) {
  let primaryColor = lordIconColors.primary;
  let secondaryColor = lordIconColors.secondary;
  const customColorId = icon.getAttribute('custom-color-id');
  if (customColorId) {
    primaryColor = lordIconColors.customColors[customColorId].primaryColor;
    secondaryColor = lordIconColors.customColors[customColorId].secondaryColor;
  }
  switch (icon.getAttribute('activeIcon')) {
    case 'true':
      icon.setAttribute('colors',`primary:${primaryColor},secondary:${secondaryColor}`);
      icon.setAttribute('activeIcon',false);
      break;

    case 'false':
      icon.setAttribute('colors',`primary:${lordIconColors.active},secondary:${lordIconColors.active}`);
      icon.setAttribute('activeIcon',true);
      break;
  }
}

